import Input from 'components/Form/Input'
import RichEditor from 'components/RichEditor'
import Select from 'components/Select'
import { Form, FormItem } from 'components/UIComponents/FormStyles'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { IsValidEmail } from 'utils/emailValidation'

import {
  FlexWrapper,
  LabelDiv,
  RichWrapper,
  SelectWrapper,
  Wrapper,
} from './style'
const CompanyDetails = ({
  handleAddNewCompany,
  getListOfCountries,
  getListOfStates,
  getListOfCities,
  saveCorporate,
  setSaveCorporate,
  addNewCompany,
}) => {
  const [companyForm] = Form.useForm()
  const instituteId = useSelector(state => state.auth.instituteDetails.id)

  const [stateList, setStateList] = useState([])
  const [searchState, setSearchState] = useState('')
  const [countryList, setCountryList] = useState([])
  const [searchCountry, setSearchCountry] = useState('')
  const [selectedCountry, setSelectedCountry] = useState('')
  const [selectedState, setSelectedState] = useState('')
  const [cityList, setCityList] = useState([])
  const [searchCity, setSearchCity] = useState('')

  const onChangeHandler = (value, key) => {
    setSaveCorporate(false)
    companyForm.setFieldsValue({
      companyDetails: {
        [key]: value,
      },
    })
  }
  useEffect(() => {
    let getData
    getData = setTimeout(() => {
      getCountries()
    }, 500)
    return () => clearTimeout(getData)
  }, [searchCountry])

  const getCountries = async () => {
    const { data, status } = await getListOfCountries({
      searchValue: searchCountry,
    })
    if (status >= 200 && status <= 300) {
      setCountryList(data?.data?.result)
    } else {
      setCountryList([])
    }
  }
  useEffect(() => {
    let getData
    if (selectedCountry && Object?.keys(selectedCountry)?.length > 0) {
      if (searchState) {
        getData = setTimeout(() => {
          getStates()
        }, 500)
      } else {
        getStates()
      }
    }
    return () => clearTimeout(getData)
  }, [searchState, selectedCountry])

  const getStates = async () => {
    const { data, status } = await getListOfStates({
      searchValue: searchState,
      countryId: selectedCountry?.option?._id,
    })
    if (status >= 200 && status <= 300) {
      setStateList(data?.data?.result)
    } else {
      setStateList([])
    }
  }
  useEffect(() => {
    let getData
    if (Object.keys(selectedState)?.length > 0) {
      if (searchState) {
        getData = setTimeout(() => {
          getCities()
        }, 500)
      } else {
        getCities()
      }
    }
    return () => clearTimeout(getData)
  }, [searchCity, selectedState])

  const getCities = async () => {
    const { data, status } = await getListOfCities({
      searchValue: searchCity,
      stateId: selectedState?.option?._id,
    })
    if (status >= 200 && status <= 300) {
      setCityList(data?.data?.result)
    } else {
      setCityList([])
    }
  }
  const onSubmitFormData = async (data, isRole) => {
    try {
      const formData = await companyForm.validateFields()
      addNewCompany(formData?.companyDetails, handleAddNewCompany)
    } catch (errorInfo) {}
  }

  const processHTMLContent = htmlString => {
    const tempElement = document.createElement('div')
    tempElement.innerHTML = htmlString
    return tempElement.innerText
  }
  useEffect(() => {
    if (saveCorporate) {
      companyForm.setFieldsValue({
        companyDetails: {
          instituteCampusId: instituteId,
        },
      })
      onSubmitFormData(companyForm, false)
    }
  }, [saveCorporate])
  return (
    <Wrapper>
      <Form onSubmit={onSubmitFormData} id={'companyForm'} form={companyForm}>
        <FormItem
          name={['companyDetails', 'companyName']}
          rules={[{ required: true, message: 'Please enter company name' }]}
        >
          <LabelDiv>Company Name *</LabelDiv>
          <Input
            width="100%"
            type="text"
            placeholder="Enter Company Name"
            onChange={({ target }) => {
              onChangeHandler(target.value, 'companyName')
            }}
          />
        </FormItem>

        <FormItem
          name={['companyDetails', 'website']}
          rules={[{ required: true, message: 'Please enter company Website' }]}
        >
          <LabelDiv>Company Website *</LabelDiv>
          <Input
            width="100%"
            type="text"
            placeholder="Enter Company Website"
            onChange={({ target }) => {
              onChangeHandler(target.value, 'website')
            }}
          />
        </FormItem>
        <FlexWrapper>
          <SelectWrapper>
            <FormItem
              name={['companyDetails', 'country']}
              rules={[{ required: false, message: 'Please enter country' }]}
            >
              <LabelDiv>Country </LabelDiv>
              <Select
                width="100%"
                valueParam="name"
                placeholder="Eg. India"
                OptionData={countryList}
                optionLabelProp="name"
                onSearch={value => setSearchCountry(value)}
                onChange={(selectedCountryId, option) => {
                  if (option) {
                    setSelectedCountry(option)

                    onChangeHandler(selectedCountryId, 'country')
                  }
                }}
              />
            </FormItem>
          </SelectWrapper>
          <SelectWrapper>
            <FormItem
              name={['companyDetails', 'state']}
              rules={[{ required: false, message: 'Please enter state' }]}
            >
              <LabelDiv>State </LabelDiv>
              <Select
                width="100%"
                OptionData={stateList}
                nameParam="name"
                valueParam="name"
                placeholder="Select State"
                onSearch={value => setSearchState(value)}
                onChange={(selectedStateId, option) => {
                  if (option) {
                    setSelectedState(option)

                    onChangeHandler(selectedStateId, 'state')
                  }
                }}
              />
            </FormItem>
          </SelectWrapper>
        </FlexWrapper>
        <FlexWrapper>
          <SelectWrapper>
            <FormItem
              name={['companyDetails', 'city']}
              rules={[{ required: false, message: 'Please enter city' }]}
            >
              <LabelDiv>City </LabelDiv>
              <Select
                width="100%"
                placeholder="Select City"
                OptionData={cityList}
                nameParam="name"
                valueParam="name"
                onSearch={value => {
                  setSearchCity(value)
                }}
                onChange={(selectedCityId, option) => {
                  if (option) {
                    onChangeHandler(selectedCityId, 'city')
                  }
                }}
              />
            </FormItem>
          </SelectWrapper>
          <SelectWrapper>
            <FormItem
              name={['companyDetails', 'postalCode']}
              rules={[{ required: false, message: 'Please enter pinCode' }]}
            >
              <LabelDiv>Pincode </LabelDiv>
              <Input
                width="100%"
                type="text"
                placeholder="Enter Pincode "
                onChange={({ target }) => {
                  onChangeHandler(target.value, 'postalCode')
                }}
              />
            </FormItem>
          </SelectWrapper>
        </FlexWrapper>

        <FormItem name={['companyDetails', 'description']}>
          <RichWrapper>
            <RichEditor
              labelName="Company Description"
              placeholder="Enter Company Description here.."
              onChange={data => {
                const plainTextContent = processHTMLContent(data)
                onChangeHandler(plainTextContent, 'description')
              }}
            />
          </RichWrapper>
        </FormItem>
        <FormItem name={['companyDetails', 'pocName']}>
          <LabelDiv>POC Name</LabelDiv>
          <Input
            width="100%"
            placeholder="Enter POC Name"
            onChange={({ target }) => {
              onChangeHandler(target.value, 'pocName')
            }}
            type="text"
          />
        </FormItem>
        <FormItem name={['companyDetails', 'pocNumber']}>
          <LabelDiv>POC Number</LabelDiv>
          <Input
            width="100%"
            placeholder="Enter POC Number"
            onChange={({ target }) => {
              onChangeHandler(target.value, 'pocNumber')
            }}
            type="number"
          />
        </FormItem>
        <FormItem name={['companyDetails', 'pocMail']}>
          <LabelDiv>POC Email</LabelDiv>
          <Input
            width="100%"
            placeholder="Enter POC Mail"
            onChange={({ target }) => {
              onChangeHandler(target.value, 'pocEmail')
            }}
            type="mail"
            rules={[
              () => ({
                validator(_, value) {
                  let isValid = IsValidEmail(value)
                  if (!isValid) {
                    return Promise.reject(new Error(`Please Enter Valid Email`))
                  }

                  return Promise.resolve()
                },
              }),
            ]}
          />
        </FormItem>
        <FormItem name={['companyDetails', 'instituteCampusId']} />
      </Form>
    </Wrapper>
  )
}

export default CompanyDetails
